export function getSearchParams() {
  let jiraLocation;
  if (window.frameElement !== null && window.frameElement !== undefined) {
    jiraLocation = window.parent.location;
  } else {
    jiraLocation = window.location;
  }

  return new URLSearchParams(new URL(jiraLocation.href).search);
}
